export const OppositeTypes = {
  'newIban': 'oldIban',
  'oldIban': 'newIban'
};
